import React from "react";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import LoginForm from "./LoginForm";
import { AnimatePresence, motion } from "framer-motion";
import { usePageSettings } from "../../../../contexts/PageSettingsContext";

const CheckoutLoginModal = ({ isOpen, onClose }) => {
	const { translations } = usePageSettings();

	return (
		<AnimatePresence>
			{isOpen && (
				<Dialog
					static
					open={isOpen}
					onClose={onClose}
					className="fixed inset-0 flex w-full items-center justify-center bg-ipxon-light-blue-gray/95 z-[99] p-7 transition duration-300 ease-out data-[closed]:opacity-0 "
				>
					<motion.div
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						exit={{ opacity: 0 }}
						className="fixed inset-0 bg-black/30"
					/>
					<div className="fixed inset-0 flex w-screen items-center justify-center p-4">
						<DialogPanel
							as={motion.div}
							initial={{ opacity: 0, scale: 0.95 }}
							animate={{ opacity: 1, scale: 1 }}
							exit={{ opacity: 0, scale: 0.95 }}
							className="flex flex-col gap-7 bg-ipxon-dark-gray rounded-lg p-7 z-[100] w-1/3 sm:w-[530px] min-w-[375px] sm:min-w-[530px] border !border-zinc-700"
						>
							<DialogTitle className="flex flex-col w-full">
								<div className="flex justify-between items-center">
									<p className="text-ipxon-light-medium-gray text-base">{translations["CheckoutLoginFormTitle"]}</p>
									<button
										onClick={onClose}
										className="hover:opacity-50 transition-all duration-300"
									>
										<svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M11.882 14.0722L6.79637 7.49997L11.882 0.927923C12.0882 0.661385 12.0161 0.292907 11.7212 0.106487C11.4261 -0.0799919 11.0185 -0.0145355 10.8123 0.251798L5.99998 6.47081L1.18767 0.251798C1.0878 0.122665 0.938224 0.0364788 0.766482 0.00905329C0.594983 -0.0180804 0.421675 0.0161722 0.278777 0.106501C-0.0161382 0.292907 -0.0882569 0.661385 0.117995 0.927923L5.20361 7.49997L0.117995 14.0722C0.018065 14.2012 -0.020238 14.3578 0.0101719 14.5128C0.0405173 14.6679 0.13596 14.8031 0.278777 14.8933C0.389037 14.9631 0.518215 15 0.652364 15C0.865395 15 1.06551 14.9058 1.18767 14.748L6 8.52911L10.8123 14.748C10.9343 14.9058 11.1344 15 11.3476 15C11.4818 15 11.6109 14.9631 11.7212 14.8934C11.864 14.8031 11.9595 14.6679 11.9898 14.5128C12.0202 14.3578 11.9819 14.2012 11.882 14.0722Z" fill="#71717A" />
										</svg>
									</button>
								</div>
								<p className="text-ipxon-magenta text-xs">{translations["CheckoutLoginFormMandatoryFields"]}</p>
							</DialogTitle>
							<LoginForm closeModal={onClose} />
						</DialogPanel>
					</div>
				</Dialog>
			)}
		</AnimatePresence>
	);
};

export default CheckoutLoginModal;
